import { useQuery } from '@tanstack/react-query';
import { ILocationTag } from 'src/interfaces';
import { queryKeys, requestCCApi } from 'src/utils';

export const useGetLocationTagById = (
  locationTagId?: string,
  countLocations = false,
) => {
  return useQuery<ILocationTag>({
    queryKey: queryKeys.locationTags.details(locationTagId),
    queryFn: () => getLocationTagById(locationTagId!, countLocations),
    enabled: Boolean(locationTagId),
  });
};

const getLocationTagById = async (
  id: string,
  countLocations: boolean,
): Promise<ILocationTag> => {
  if (countLocations) {
    const [tagResponse, countResponse] = await Promise.all([
      requestCCApi({
        url: `/locationTags/${id}`,
        method: 'GET',
      }),
      requestCCApi({
        url: `/getLocationTagsWithLocationCount?id=${id}&pageSize=1`,
        method: 'GET',
      }),
    ]);

    const tagWithCount = countResponse.data?.[0];

    return {
      ...tagResponse.data,
      locations_count: tagWithCount?.locations_count ?? 0,
    };
  }

  const response = await requestCCApi({
    url: `/locationTags/${id}`,
    method: 'GET',
  });

  return response.data;
};
